import authService from './auth.service';
import * as apiService from './api.service';

export default {
    auth: authService,
    api: apiService
}